import Select from "@material-ui/core/Select";
import React, {Component, ReactElement} from "react";
import {MenuItem} from "@material-ui/core";

const DatesCulturePreferenceKey = "DATES_CULTURE";

interface Culture {
  name: string;
  datesFormat: string;
}

const SupportedCultures: Culture[] = [
  {
    name: "en-us",
    datesFormat: "MM/DD/YYYY",
  },
  {
    name: "en-gb",
    datesFormat: "DD/MM/YYYY",
  },
];

interface Preferences {
  datesCulture: string;
}

// Basic, simple preferences page to handle date formats, using localStorage.
export default class PreferencesRegion extends Component<
  unknown,
  Preferences
> {
  constructor(props: unknown) {
    super(props);

    this.state = {
      datesCulture: "",
    };
  }

  onCultureSelect(event: React.ChangeEvent<{value: unknown}>): void {
    const value = event.target.value as string;

    localStorage.setItem(DatesCulturePreferenceKey, value);

    this.setState({
      datesCulture: value,
    });
  }

  readInitialValues(): Preferences {
    return {
      datesCulture: localStorage.getItem(DatesCulturePreferenceKey) || "en-gb",
    };
  }

  componentDidMount(): void {
    this.setState(this.readInitialValues());
  }

  render(): ReactElement {
    const {datesCulture} = this.state;

    return (
      <section>
        <h1>Preferences</h1>
        <dl>
          <dt>Dates format</dt>
          <dd>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={datesCulture}
              onChange={this.onCultureSelect.bind(this)}
            >
              {SupportedCultures.map((item) => {
                return (
                  <MenuItem key={item.name} value={item.name}>
                    {item.name.toUpperCase()}&emsp;({item.datesFormat})
                  </MenuItem>
                );
              })}
            </Select>
          </dd>
        </dl>
      </section>
    );
  }
}
